module.exports = __webpack_public_path__ + "img/swipe-dark.1eda1583.svg";